import { registerPlugin } from '@capacitor/core';
const BluetoothPrinter = registerPlugin('BluetoothPrinter', {
    web: () => import('./web').then(m => new m.BluetoothPrinterWeb()),
});
export * from './definitions';
export { BluetoothPrinter };
//# sourceMappingURL=index.js.map